import Layout from '@/layout/paycools-index.vue'

export const financialRouter = {
  path: '/financialManage',
  component: Layout ,
  redirect: '/financialManage/balance',
  name: 'Financial_Manage',
  meta: { title: 'financial', icon: 'financial' },
  alwaysShow: true,
  children: [
    {
      path: 'balance',
      name: 'Financial_Manage_Balance',
      component: () => import('@/views/paycools/data/balance.vue'),
      meta: {
        title: 'balance', noCache: false,
        auth: ['AUTH_CODE_BALANCE']
      }
    },
    {
      path: 'setting',
      name: 'Financial_Manage_Setting',
      component: () => import('@/views/paycools/data/financial-setting.vue'),
      meta: {
        title: 'financial_setting', noCache: false,
        auth: ['AUTH_CODE_FINANCIALS_SETTING']
      }
    },
    {
      path: 'FXQuery',
      name: 'Financial_Manage_FXQuery',
      component: () => import('@/views/paycools/data/fx-query.vue'),
      meta: {
        title: 'fx_query', noCache: false,
        auth: ['AUTH_CODE_FOREIGN_EXCHANGE_RATE_QUERY']
      }
    },
    {
      path: 'balance/detail',
      name: 'Financial_Manage_Balance_Detail',
      component: () => import('@/views/paycools/data/balance-trans-detail.vue'),
      meta: {
        title: 'balance_details', noCache: false,
        auth: ['AUTH_CODE_BALANCE'],
        activeMenu: '/financialManage/balance'
      },
      hidden: true
    },
    {
      path: 'balance/recharge',
      name: 'Financial_Manage_Balance_Recharge',
      component: () => import('@/views/paycools/data/balance-recharge.vue'),
      meta: {
        title: 'top_up', noCache: false,
        auth: ['AUTH_CODE_RECHARGE']
      },
      hidden: true
    },
    {
      path: 'balance/recharge/qr',
      name: 'Financial_Manage_Balance_Recharge_QR',
      component: () => import('@/views/paycools/data/balance-recharge-qr-pay.vue'),
      meta: {
        title: 'top_up', noCache: false,
        auth: ['AUTH_CODE_RECHARGE']
      },
      hidden: true
    }
  ]
}

export const financialAgentRouter = {
  path: '/financialManage/agent',
  component: Layout,
  redirect: '/financialManage/agent/balance',
  name: 'Financial_Manage',
  meta: { title: 'financial', icon: 'financial' },
  alwaysShow: true,
  children: [
    {
      path: 'balance',
      name: 'Financial_Manage_Agent_Balance',
      component: () => import('@/views/paycools/financials-agent/balance.vue'),
      meta: {
        title: 'balance', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'setting',
      name: 'Financial_Manage_Agent_Setting',
      component: () => import('@/views/paycools/data/financial-setting.vue'),
      meta: {
        title: 'financial_setting', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    },
    {
      path: 'balance/detail',
      name: 'Financial_Manage_Agent_Balance_Detail',
      component: () => import('@/views/paycools/financials-agent/balance-trans-detail.vue'),
      meta: {
        title: 'balance_details', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN'],
        activeMenu: '/financialManage/agent/balance'
      },
      hidden: true
    }
  ]
}
